export const BackgroundTasksStatus = {
  Processing: 'Processing',
  Failed: 'Failed',
  Completed: 'Completed',
} as const;
export type BackgroundTasksStatus = (typeof BackgroundTasksStatus)[keyof typeof BackgroundTasksStatus];
